<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-14 12:56:09
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:55:52
 * @name: 型号表格
 * @Description: 型号表格
 * @FilePath: \preSaleNafterSaleBackstage\src\components\modelGoodsManage\table-model.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div>
    <layout v-show="step === 3" :step="step">
      <template v-slot:head>
        <el-button size="mini" plain @click="modelAdd">添加型号</el-button>
        <el-button size="mini" plain @click="backSeries">返回系列</el-button>
      </template>
      <template v-slot:bar>
        <font>当前品牌: {{ modelGoods.table_series_data.category_name }}</font>
        <font>当前系列: {{ modelGoods.table_model_data.category_name }}</font>
      </template>
      <template v-slot:table>
        <el-table
          :data="modelGoods.table_model_data.list"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
        >
          <el-table-column align="center" prop="id" label="ID">
          </el-table-column>
          <el-table-column align="center" prop="level_name" label="级别">
          </el-table-column>
          <el-table-column align="center" prop="category_name" label="名称">
          </el-table-column>
          <el-table-column align="center" label="查看商品">
            <template slot-scope="scope">
              <el-button type="text" @click="modelNext(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="statistics_count"
            label="商品数量"
          >
          </el-table-column>
          <el-table-column align="center" label="状态">
            <template slot-scope="scope">
              <el-switch
                :active-value="1"
                :inactive-value="0"
                :value="scope.row.status"
                @change="modelStatusChange($event, scope.row.id)"
                active-color="#13ce66"
                :inactive-color="$scssVars['Vars-font-placeholder-color']"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="180"
          >
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="modelEdit(scope.row)"
                >编辑</el-button
              ><font class="clip">|</font>
              <el-button size="mini" type="text" @click="modelDel(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:pagination>
        <Pagination
          v-if="pagination.page"
          :page.sync="pagination.page"
          :page-size.sync="pagination.limit"
          :total="Number(modelGoods.table_model_data.total)"
        ></Pagination>
      </template>
    </layout>
    <addNedit-model
      ref="addNeditModel"
      :modelGoods="modelGoods"
      @add="modelAddHandler"
      @edit="modelEditHandler"
    ></addNedit-model>
  </div>
</template>
<script>
import layout from "@/components/modelGoodsManage/layout.vue";
import addNeditModel from "./dialog/addNedit-model.vue";
import { confirmation,debounceation } from "@/utils/decorator";

export default {
  name: "modelGoodsManage-tableModel",
  components: {
    layout,
    addNeditModel,
  },
  props: {
    step: {
      type: Number,
    },
    modelGoods: {
      type: Object,
    },
  },
  data() {
    // methods -> initData内初始化
    return {
      loading: false, //表格加载状态
      pagination: {}, //品牌表格分页信息
    };
  },
  watch: {
    // 分页器发生变化,更新表格
    pagination: {
      handler(nv, ov) {
        ov.page && this.getTableData();
      },
      immediate: false,
      deep: true,
    },
    // 监听当前系列id, 当前系列id变化且有值,获取该系列下级型号表格数据
    "modelGoods.table_model_data.id": {
      handler(nv, ov) {
        if (nv) {
          this.initData();
          this.getTableData();
        }
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 刷新组件
     */
    refresh() {
      this.initData();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化data
     */
    initData() {
      this.modelGoods.table_model_data.total = 0;
      this.modelGoods.table_model_data.list = [];
      this.pagination = {
        //品牌表格分页信息
        page: 1, //当前页码
        limit: 10, //每页数据量
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取型号表格数据
     */
    getTableData() {
      this.loading = true;
      let parent_id = this.modelGoods.table_model_data.id;
      let params = { parent_id, ...this.pagination };
      this.modelGoods.getTableModelData(params).finally(() => {
        this.loading = false;
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 返回系列
     */
    backSeries() {
      this.$emit("update:step", 2);
      this.modelGoods.table_model_data.id = "";
      this.modelGoods.table_model_data.category_name = "";
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 变化型号表格中型号的状态
     * @param {Boolean} e 变化值
     * @param {Number | String} id 型号id
     */
    @debounceation(300)
    modelStatusChange(e, id) {
      this.modelGoods.modelStatusChange({
        category_id: id,
        status: e,
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 查看商品
     * @param {Object} row 型号表格行数据
     */
    @debounceation(300)
    modelNext(row) {
      this.$router.replace({
        name: "waresGoodsManage",
        params: { category_id: row.id },
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 型号添加
     */
    @debounceation(300)
    modelAdd() {
      this.$refs.addNeditModel.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 添加型号弹窗回传
     * @param {Object} form 回传数据
     */
    modelAddHandler(form) {
      this.modelGoods.addModel(form).then((res) => {
        this.getNewTableData();
        this.$refs.addNeditModel.cancel();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 型号编辑
     * @param {Object} row 型号表格行数据
     */
    @debounceation(300)
    modelEdit(row) {
      this.$refs.addNeditModel.open(row);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 编辑型号弹窗回传
     * @param {Object} form 回传数据
     */
    modelEditHandler(form) {
      this.modelGoods.editModel(form).then((res) => {
        this.getNewTableData();
        this.$refs.addNeditModel.cancel();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 删除型号
     * @param {Object} row 型号表格行数据
     */
    @confirmation((row) => `确认删除型号名为${row.category_name}的型号?`)
    modelDel(row) {
      this.modelGoods.delModel({ category_id: row.id }).then((res) => {
        this.getNewTableData();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 操作后更新表格数据
     */
    getNewTableData() {
      this.getTableData();
      this.$emit("getNewTableData", "tableSeries"); //更新品牌表数据
    },
  },
};
</script>
<style lang="scss" scoped>
.el-table {
  .el-button {
    margin: 0;
    padding: 0 6px;
  }
  .clip {
    color: $Vars-font-placeholder-color;
  }
  /deep/ .el-switch__core:before {
    content: "隐";
    color: white;
    font-size: $Vars-font-secondary-size;
    line-height: $Vars-font-secondary-size;
    position: absolute;
    top: 3px;
    left: 21px;
  }
  /deep/.is-checked .el-switch__core:before {
    content: "显" !important;
    color: white;
    font-size: $Vars-font-secondary-size;
    line-height: $Vars-font-secondary-size;
    position: absolute;
    top: 3px;
    left: 5px;
  }
}
</style>